export default __webpack_public_path__ + "static/media/assets-photos.aef86964.jpg";